import { createInertiaApp } from "@inertiajs/react";
import { createElement } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { initializeVisualEditor } from "../lib/visual-editor.js";

createInertiaApp({
	resolve: (name) => {
		const pages = import.meta.glob("../pages/**/*.jsx");
		return pages[`../pages/${name}.jsx`]();
	},

	setup({ el, App, props }) {
		if (el) {
			if (import.meta.env.MODE === "production") {
				hydrateRoot(el, createElement(App, props));
			} else {
				createRoot(el).render(createElement(App, props));
			}

			if (typeof window !== "undefined") {
				setTimeout(() => {
					initializeVisualEditor();
				}, 500);
			}
		} else {
			console.error(
				"Missing root element.\n\n" +
					"If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
					'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
			);
		}
	},
});
